<section class="dash-page">
  <app-filter-dashboard (changesDates)="onFilterDates($event)"/>
  <p-tabView>
    <p-tabPanel [header]="translations.tabTramites">
      <ng-template pTemplate="content">
        <app-dashboard-general-tramites [fechaInicial]="fechaInicial"
                                        [fechaFinal]="fechaFinal" [tramRecibidos]="translations.tramRecibidos"/>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel [header]="translations.tabPqrsdf">
      <ng-template pTemplate="content">
        <app-dashboard-general-pqrsdf [fechaInicial]="fechaInicial"
                                      [fechaFinal]="fechaFinal"
                                      [solicitudesRecibidas]="translations.solicitudesRecibidas"/>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</section>
